import React from 'react';
export function ProductSection() {
  return <section className="py-6 md:py-9 px-5 bg-[radial-gradient(ellipse_at_top,rgba(107,0,182,0.2)_0%,transparent_60%),var(--dark-bg)]" data-id="element-200" data-mp="1hytw3g9vjwxz">
      <div className="max-w-[900px] mx-auto" data-id="element-201" data-mp="hj086lw8xke4">
        <span className="inline-block font-heading font-bold text-[0.75rem] tracking-[3px] uppercase text-magenta-bright mb-2" data-id="element-202" data-mp="hkutw2fcdgj9">
          Il metodo
        </span>
        <h2 className="text-[clamp(1.6rem,4vw,2.5rem)] font-heading font-black leading-[1.15] mb-3" data-id="element-203" data-mp="qjf40f6u6hvv">
          La collezione che
          <br data-id="element-204" data-mp="mhl8elbi042k" />
          <span className="text-gradient-magenta" data-id="element-205" data-mp="mi3esarvjyo7">va alla radice</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-[1fr_1.2fr] gap-5 md:gap-8 items-center mt-4" data-id="element-206" data-mp="10gt77d3r1a68">
          <div className="w-full" data-id="element-207" data-mp="vjkqlgy91e73">
            <img src="https://cdn.magicpatterns.com/uploads/pJZQQ1y91fqaN7VirMLzzV/oDiXxM0087776.webp" alt="Collezione Piacere, Colpa e Vuoto — 4 volumi" className="w-full rounded-2xl drop-shadow-[0_20px_50px_rgba(194,0,111,0.4)]" data-id="element-208" data-mp="vh87v1ko2zsz" />
          </div>
          <div data-id="element-209" data-mp="1b7796yp8g0g">
            <h3 className="text-[clamp(1.5rem,3vw,2.2rem)] font-heading font-black mb-[10px] text-white" data-id="element-210" data-mp="1axpu7rpzh6d">
              PIACERE, COLPA E VUOTO
            </h3>
            <div className="flex gap-2 my-3 flex-wrap" data-id="element-211" data-mp="5aoea4trxl7q">
              <span className="bg-gradient-to-br from-purple-mid to-magenta py-2 px-[18px] rounded-full font-heading font-bold text-[0.85rem]" data-id="element-212" data-mp="a3rdotl8fovu">
                📘 Volume 1
              </span>
              <span className="bg-gradient-to-br from-purple-mid to-magenta py-2 px-[18px] rounded-full font-heading font-bold text-[0.85rem]" data-id="element-213" data-mp="k0w08uizpmd6">
                📗 Volume 2
              </span>
              <span className="bg-gradient-to-br from-purple-mid to-magenta py-2 px-[18px] rounded-full font-heading font-bold text-[0.85rem]" data-id="element-214" data-mp="t2vgvlq3eofl">
                📙 Volume 3
              </span>
              <span className="bg-gradient-to-br from-purple-mid to-magenta py-2 px-[18px] rounded-full font-heading font-bold text-[0.85rem]" data-id="element-215" data-mp="2ut6wp2e7m9ax">
                📕 Volume 4
              </span>
            </div>
            <div className="text-[0.95rem] leading-[1.6] text-white/80 space-y-2" data-id="element-216" data-mp="3t6ci0d2xuz54">
              <p data-id="element-217" data-mp="azogsyb0ew4q">
                Una collezione di 4 volumi pensata come sistema progressivo:
                ognuno approfondisce un punto del ciclo P-C-V e ti dà gli
                strumenti specifici per lavorarci.
              </p>
              <p data-id="element-218" data-mp="kwt26vx16nkh">
                Non è un libro da leggere e mettere via. È un sistema da{' '}
                <strong data-id="element-219" data-mp="fy80st61lxug">fare</strong> — con pratiche da 5 a 15 minuti al giorno
                che non richiedono che nessun altro lo sappia.
              </p>
              <p data-id="element-220" data-mp="pp2pe46rh9j2">
                Inizi da dove sei.{' '}
                <strong className="text-magenta-bright" data-id="element-221" data-mp="ppm6xjsi1vwk">Oggi.</strong>
              </p>
            </div>
            <div className="mt-4 p-4 rounded-2xl bg-gradient-to-br from-[rgba(194,0,111,0.1)] to-[rgba(107,0,182,0.1)] border border-magenta-bright/30" data-id="element-222" data-mp="13ovexw6jxjpg">
              <p className="font-heading font-black text-[1.05rem] text-gold mb-0.5 uppercase tracking-[1px]" data-id="element-223" data-mp="1ib11kvq0fyoo">
                🎁 In regalo 3 bonus
              </p>
              <p className="text-[0.85rem] text-magenta-bright font-heading font-bold mb-2.5" data-id="element-224" data-mp="19amfhu582fk4">
                Oggi con l'acquisto — <span className="uppercase" data-id="element-225" data-mp="1dbxznk5bu8kx">GRATIS</span>
              </p>
              <div className="space-y-2.5" data-id="element-226" data-mp="1de2bqpddqdwa">
                <div className="flex items-start gap-4 bg-[rgba(107,0,182,0.12)] rounded-xl p-3 border border-white/5" data-id="element-227" data-mp="zjrsgnk5jbxm">
                  <img src="https://cdn.magicpatterns.com/uploads/nMZ13FC2JgavAGyiiGzKCh/unnamed_(4).png" alt="Piano di 30 giorni: dai vizi alla disciplina" className="w-[80px] rounded-lg shrink-0 drop-shadow-[0_4px_12px_rgba(0,0,0,0.4)]" data-id="element-228" data-mp="14d44ly7n9q9h" />
                  <div data-id="element-229" data-mp="go1o4toqy3gk">
                    <span className="inline-block bg-gradient-to-br from-purple-mid to-magenta text-white font-heading font-black text-[0.7rem] tracking-[1px] uppercase py-0.5 px-2 rounded mb-1.5" data-id="element-230" data-mp="ll1s8z21cw51">
                      BONUS 1
                    </span>
                    <p className="font-heading font-bold text-white text-[0.95rem] leading-tight" data-id="element-231" data-mp="8lsnotirv0iw">
                      Piano di 30 giorni: dai vizi alla disciplina
                    </p>
                    <p className="text-white/50 text-[0.8rem] leading-relaxed mt-1" data-id="element-232" data-mp="3vxjysm7dp8a2">
                      Guida passo a passo con esercizi quotidiani per sostituire
                      le abitudini distruttive con routine che rafforzano la tua
                      disciplina.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-[rgba(107,0,182,0.12)] rounded-xl p-3 border border-white/5" data-id="element-233" data-mp="3czh4brw2aj4v">
                  <img src="https://cdn.magicpatterns.com/uploads/aBaUcJ67RpJSyimUaQ9Px4/unnamed_(3).png" alt="Capire la dopamina e il cervello dipendente" className="w-[80px] rounded-lg shrink-0 drop-shadow-[0_4px_12px_rgba(0,0,0,0.4)]" data-id="element-234" data-mp="1fa7nqs1v3abi" />
                  <div data-id="element-235" data-mp="2y3sg85sznmph">
                    <span className="inline-block bg-gradient-to-br from-purple-mid to-magenta text-white font-heading font-black text-[0.7rem] tracking-[1px] uppercase py-0.5 px-2 rounded mb-1.5" data-id="element-236" data-mp="2y2zghosg5xgu">
                      BONUS 2
                    </span>
                    <p className="font-heading font-bold text-white text-[0.95rem] leading-tight" data-id="element-237" data-mp="2a7eoe08kcfiy">
                      Capire la dopamina e il cervello dipendente
                    </p>
                    <p className="text-white/50 text-[0.8rem] leading-relaxed mt-1" data-id="element-238" data-mp="2j7tbn55384p3">
                      Scopri come funziona il sistema di ricompensa del tuo
                      cervello e perché ricadi in schemi ripetitivi.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-[rgba(107,0,182,0.12)] rounded-xl p-3 border border-white/5" data-id="element-239" data-mp="3g5eb8m5wa5r">
                  <img src="https://cdn.magicpatterns.com/uploads/renZEirDDVqjtt9rixQ7AY/unnamed_(2).png" alt="Come gestire una ricaduta senza distruggere il tuo percorso" className="w-[80px] rounded-lg shrink-0 drop-shadow-[0_4px_12px_rgba(0,0,0,0.4)]" data-id="element-240" data-mp="1zis7xn6yo45r" />
                  <div data-id="element-241" data-mp="24jfy66nd8gyx">
                    <span className="inline-block bg-gradient-to-br from-purple-mid to-magenta text-white font-heading font-black text-[0.7rem] tracking-[1px] uppercase py-0.5 px-2 rounded mb-1.5" data-id="element-242" data-mp="1gt24yct1oc2r">
                      BONUS 3
                    </span>
                    <p className="font-heading font-bold text-white text-[0.95rem] leading-tight" data-id="element-243" data-mp="1qjnc4omsaoxa">
                      Come gestire una ricaduta senza distruggere il tuo
                      percorso
                    </p>
                    <p className="text-white/50 text-[0.8rem] leading-relaxed mt-1" data-id="element-244" data-mp="y0hppy69q5hf">
                      Strategie concrete perché un inciampo non diventi una
                      caduta libera e tu possa riprendere il cammino.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}